const REMEMBER_ME_KEY = 'tamcare_remember_me';
const REMEMBER_USERNAME_KEY = 'tamcare_remember_username';
const REMEMBER_PASSWORD_KEY = 'tamcare_remember_password';

function encodePassword(password) {
  try {
    return btoa(unescape(encodeURIComponent(String(password))));
  } catch (_) {
    return '';
  }
}

function decodePassword(encoded) {
  if (!encoded) return '';
  try {
    return decodeURIComponent(escape(atob(encoded)));
  } catch (_) {
    return '';
  }
}

export function getRememberLoginPref() {
  return localStorage.getItem(REMEMBER_ME_KEY) === '1';
}

export function readRememberLoginFormState() {
  const rememberMe = getRememberLoginPref();
  return {
    rememberMe,
    usernameOrEmail: rememberMe ? getRememberedUsername() : '',
    password: rememberMe ? getRememberedPassword() : '',
  };
}

export function getRememberedUsername() {
  return localStorage.getItem(REMEMBER_USERNAME_KEY) || '';
}

export function getRememberedPassword() {
  if (!getRememberLoginPref()) return '';
  return decodePassword(localStorage.getItem(REMEMBER_PASSWORD_KEY) || '');
}

export function saveRememberLogin(username, password, remember) {
  if (remember && username) {
    localStorage.setItem(REMEMBER_ME_KEY, '1');
    localStorage.setItem(REMEMBER_USERNAME_KEY, String(username).trim());
    if (password) {
      localStorage.setItem(REMEMBER_PASSWORD_KEY, encodePassword(password));
    } else {
      localStorage.removeItem(REMEMBER_PASSWORD_KEY);
    }
    return;
  }
  clearRememberLogin();
}

export function clearRememberLogin() {
  localStorage.removeItem(REMEMBER_ME_KEY);
  localStorage.removeItem(REMEMBER_USERNAME_KEY);
  localStorage.removeItem(REMEMBER_PASSWORD_KEY);
}
